import View from '../Support/View/View';
import Form from './Form';

export default class Recaptcha extends View {
    #formView = null;

    static get viewName() {
        return 'recaptcha';
    }
    static get viewType() {
        return 'component';
    }

    start() {
        setTimeout(() => this.#setupRecaptcha(), 0);
    }

    /**
     * @returns {Form|null}
     */
    get form() {
        if (this.#formView) {
            return this.#formView;
        }

        const target = this.$el.getAttribute('for');

        if (!target) {
            return null;
        }

        const form = document.querySelector(`#${target}`);

        if (!form) {
            return null;
        }

        return this.#formView = (View.instances.get(form.dataset.viewId) ?? null);
    }

    /**
     * @returns {Promise}
     */
    execute() {
        return grecaptcha.execute();
    }

    /**
     * @returns {void}
     */
    reset() {
        grecaptcha.reset();
    }

    /**
     * @returns {String}
     */
    getResponse() {
        return grecaptcha.getResponse();
    }

    #setupRecaptcha() {
        if (!this.viewData.key) {
            return;
        }

        const interval = setInterval(() => {
            if (!window?.grecaptcha?.render) {
                return;
            }

            clearInterval(interval);

            grecaptcha.render(this.$el, { sitekey: this.viewData.key, size: 'invisible'/* , callback: this.callback */ });
        }, 100);

        setTimeout(() => clearInterval(interval), 2000);
    }
}